<template>
  <div class="lad-landing-begin-end-days--wrapper">
    <div class="begin-end-days--container">
      <div class="begin-end-days-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="28"
          viewBox="0 0 21 28"
          fill="none"
        >
          <path
            d="M10.625 25.4551C11.0078 25.4186 11.7096 25.0085 12.7305 24.2246C13.7513 23.4408 14.7995 22.4564 15.875 21.2715C17.2422 19.722 18.3086 18.1087 19.0742 16.4316C19.8398 14.7546 20.2318 13.0957 20.25 11.4551C20.1771 8.83008 19.2428 6.72461 17.4473 5.13867C15.6517 3.55273 13.3776 2.74154 10.625 2.70508C7.8724 2.74154 5.59831 3.55273 3.80273 5.13867C2.00716 6.72461 1.07292 8.83008 1 11.4551C1.01823 13.1139 1.41016 14.7773 2.17578 16.4453C2.94141 18.1133 4.00781 19.722 5.375 21.2715C6.45052 22.4564 7.4987 23.4408 8.51953 24.2246C9.54036 25.0085 10.2422 25.4186 10.625 25.4551ZM10.625 13.5605C11.1172 13.5423 11.5273 13.3691 11.8555 13.041C12.1836 12.7129 12.3477 12.3027 12.3477 11.8105C12.3477 11.3184 12.1836 10.9036 11.8555 10.5664C11.5273 10.2292 11.1172 10.0605 10.625 10.0605C10.1328 10.0605 9.72266 10.2292 9.39453 10.5664C9.06641 10.9036 8.90234 11.3184 8.90234 11.8105C8.90234 12.3027 9.06641 12.7129 9.39453 13.041C9.72266 13.3691 10.1328 13.5423 10.625 13.5605ZM10.625 17.416C9.03906 17.3613 7.71745 16.8099 6.66016 15.7617C5.60286 14.7135 5.05599 13.3965 5.01953 11.8105C5.05599 10.2246 5.60286 8.90299 6.66016 7.8457C7.71745 6.78841 9.03906 6.24154 10.625 6.20508C12.2109 6.24154 13.5326 6.78841 14.5898 7.8457C15.6471 8.90299 16.194 10.2246 16.2305 11.8105C16.194 13.3965 15.6471 14.7135 14.5898 15.7617C13.5326 16.8099 12.2109 17.3613 10.625 17.416Z"
            fill="#1D1D1D"
          />
          <circle cx="10.5" cy="11.5" r="2.5" fill="#1AA31C" />
        </svg>
      </div>

      <el-divider>
        <el-tag
          v-if="exExperience.duration"
          effect="plain"
          class="begin-end-days--duration"
        >
          {{
            $tc(`${base}.days`, exExperience.duration, {
              days: exExperience.duration,
            })
          }}
        </el-tag>
      </el-divider>

      <div class="begin-end-days-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="28"
          viewBox="0 0 21 28"
          fill="none"
        >
          <path
            d="M10.625 25.4551C11.0078 25.4186 11.7096 25.0085 12.7305 24.2246C13.7513 23.4408 14.7995 22.4564 15.875 21.2715C17.2422 19.722 18.3086 18.1087 19.0742 16.4316C19.8398 14.7546 20.2318 13.0957 20.25 11.4551C20.1771 8.83008 19.2428 6.72461 17.4473 5.13867C15.6517 3.55273 13.3776 2.74154 10.625 2.70508C7.8724 2.74154 5.59831 3.55273 3.80273 5.13867C2.00716 6.72461 1.07292 8.83008 1 11.4551C1.01823 13.1139 1.41016 14.7773 2.17578 16.4453C2.94141 18.1133 4.00781 19.722 5.375 21.2715C6.45052 22.4564 7.4987 23.4408 8.51953 24.2246C9.54036 25.0085 10.2422 25.4186 10.625 25.4551ZM10.625 13.5605C11.1172 13.5423 11.5273 13.3691 11.8555 13.041C12.1836 12.7129 12.3477 12.3027 12.3477 11.8105C12.3477 11.3184 12.1836 10.9036 11.8555 10.5664C11.5273 10.2292 11.1172 10.0605 10.625 10.0605C10.1328 10.0605 9.72266 10.2292 9.39453 10.5664C9.06641 10.9036 8.90234 11.3184 8.90234 11.8105C8.90234 12.3027 9.06641 12.7129 9.39453 13.041C9.72266 13.3691 10.1328 13.5423 10.625 13.5605ZM10.625 17.416C9.03906 17.3613 7.71745 16.8099 6.66016 15.7617C5.60286 14.7135 5.05599 13.3965 5.01953 11.8105C5.05599 10.2246 5.60286 8.90299 6.66016 7.8457C7.71745 6.78841 9.03906 6.24154 10.625 6.20508C12.2109 6.24154 13.5326 6.78841 14.5898 7.8457C15.6471 8.90299 16.194 10.2246 16.2305 11.8105C16.194 13.3965 15.6471 14.7135 14.5898 15.7617C13.5326 16.8099 12.2109 17.3613 10.625 17.416Z"
            fill="#1D1D1D"
          />
          <circle cx="10.5" cy="11.5" r="2.5" fill="#1AA31C" />
        </svg>
      </div>
    </div>

    <div class="begin-end-days--container">
      <div class="begin-end-days--first">
        <span>{{ $t(`${base}.it_starts_at`) }}</span>
        <span class="point">{{ exExperience.startingPoint }}</span>
      </div>

      <div class="begin-end-days--middle">&nbsp;</div>

      <div class="begin-end-days--last">
        <span>{{ $t(`${base}.ends_in`) }}</span>
        <span class="point">{{ exExperience.endingPoint }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadLandingBeginEndDaysCustom',
  data() {
    return {
      base: 'experience.sidebars.main',
    }
  },
  computed: {
    ...mapState('experience', {
      exExperience: (state) => ({
        duration: state.experience.duration,
        startingPoint: state.experience.starting_point,
        endingPoint: state.experience.ending_point,
        destinations: state.experience.destinations || [],
      }),
    }),
  },
}
</script>

<style lang="scss">
.lad-landing-begin-end-days--wrapper {
  padding: 16px 20px;
  background-color: #fff;

  .begin-end-days {
    &--container {
      display: flex;
      align-items: center;
      gap: 5px;

      .el-divider {
        border-top: 1px dashed #b1b1b1;

        &__text {
          padding: 0 5px;
          background: transparent;
        }
      }
    }

    &--duration {
      border-radius: 50px;
      border: 1.5px solid #1aa31c;
      color: #1aa31c;
      font-size: 14px;
      font-weight: 700;
    }

    &--first,
    &--middle,
    &--last {
      flex: 1;

      span {
        display: block;
        color: #1d1d1d;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;

        &.point {
          color: #1aa31c;
          font-size: 18px;
        }
      }
    }

    &--first {
      text-align: left;
    }

    &--last {
      text-align: right;
    }

    &--divider {
      height: 3px;
      margin: 20px 0;
      background-color: #ebeef2;
    }
  }
}
</style>
